import {FC} from 'react';
import {ISubsystem} from '@types';
import Text from '@atoms/Text';
import CompareSubsystemTable from '@organisms/CompareSubsystemTable';
import {
  SubsystemCompareBlockTitleWrapper,
  SubsystemCompareBlockWrapper,
} from '@organisms/SubsystemCompareBlock.styles';

import {CoverageChanges} from '@components/atoms/CoverageChanges';

export interface SubsystemCompareBlockProps {
  subsystem: ISubsystem;
}

export const SubsystemCompareBlock: FC<SubsystemCompareBlockProps> = ({subsystem}) => {
  return (
    <SubsystemCompareBlockWrapper>
      <SubsystemCompareBlockTitleWrapper>
        <Text text={`${subsystem.id}. ${subsystem.name}`} type="titleR" />
        <CoverageChanges
          coverage={subsystem.auto_coverage + subsystem.coverage}
          changes={(subsystem.auto_coverage_delta ?? 0) + (subsystem.coverage_delta ?? 0)}
        />
      </SubsystemCompareBlockTitleWrapper>
      <CompareSubsystemTable modules={subsystem.modules} onSortTests={() => {}} />
    </SubsystemCompareBlockWrapper>
  );
};

export default SubsystemCompareBlock;
